import React, { useEffect } from 'react';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom'

const AppRoute = ({ component: Component, routeKey, blankLayout, ...props }) => {

	const dispatch = useDispatch()
	const location = useLocation();

	// Rotas que NÃO devem usar o layout autenticado
	const noAuthLayoutRoutes = ['/confirmacao-presenca', '/auth/login', '/auth/register', '/auth/forgot-password', '/auth/confirm-email'];
	const isNoAuthLayout = noAuthLayoutRoutes.some(route => location.pathname.startsWith(route));

	useEffect(() => {
		dispatch(onBlankLayout(isNoAuthLayout));
		return () => dispatch(onBlankLayout(false));
	}, [isNoAuthLayout, dispatch]);

	if (isNoAuthLayout) {
		return <Component {...props} />;
	}

	return (
		<Component {...props} />
	)
}

export default AppRoute